var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAgregadores(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-agregadores",
    transform: "translate(-0.333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rect\\xE1ngulo_1883",
    "data-name": "Rect\\xE1ngulo 1883",
    transform: "translate(0.333)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 40,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 40,
    height: 39,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    transform: "translate(5.13 4.964)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_20075",
    "data-name": "Grupo 20075",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27344",
    "data-name": "Trazado 27344",
    d: "M11.944,3H7.816A4.844,4.844,0,0,0,3,7.66v3.828a4.875,4.875,0,0,0,4.816,4.827h3.956a4.885,4.885,0,0,0,4.988-4.66V7.66A4.844,4.844,0,0,0,11.944,3Zm1.376,8.655a1.456,1.456,0,0,1-1.376,1.332H7.816A1.456,1.456,0,0,1,6.44,11.655V7.66A1.456,1.456,0,0,1,7.816,6.329h3.956A1.5,1.5,0,0,1,13.32,7.66Z",
    transform: "translate(-3 -3)",
    fill: "#777"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27345",
    "data-name": "Trazado 27345",
    d: "M21.944,3H17.988A4.885,4.885,0,0,0,13,7.66v3.828a4.733,4.733,0,0,0,4.816,4.66h3.956a4.731,4.731,0,0,0,4.816-4.66V7.66A4.582,4.582,0,0,0,21.944,3Zm1.376,8.655a1.456,1.456,0,0,1-1.376,1.332H17.988a1.5,1.5,0,0,1-1.548-1.332V7.66a1.456,1.456,0,0,1,1.376-1.332h3.956A1.5,1.5,0,0,1,23.32,7.66Z",
    transform: "translate(4.676 -3)",
    fill: "#777"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27346",
    "data-name": "Trazado 27346",
    d: "M21.872,13H17.916A4.731,4.731,0,0,0,13.1,17.66v3.828a4.733,4.733,0,0,0,4.816,4.66h3.956a4.731,4.731,0,0,0,4.816-4.66V17.66A4.844,4.844,0,0,0,21.872,13Zm1.376,8.655a1.336,1.336,0,0,1-1.376,1.332H17.916a1.334,1.334,0,0,1-1.376-1.332V17.827A1.336,1.336,0,0,1,17.916,16.5h3.956a1.334,1.334,0,0,1,1.376,1.332Z",
    transform: "translate(4.748 3.644)",
    fill: "#777"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27347",
    "data-name": "Trazado 27347",
    d: "M11.944,13H7.816A4.844,4.844,0,0,0,3,17.66v3.828a4.875,4.875,0,0,0,4.816,4.827h3.956a4.731,4.731,0,0,0,4.816-4.66V17.827A4.623,4.623,0,0,0,11.944,13Zm1.376,8.655a1.456,1.456,0,0,1-1.376,1.332H7.816A1.456,1.456,0,0,1,6.44,21.655V17.827a1.487,1.487,0,0,1,1.376-1.5h3.956A1.5,1.5,0,0,1,13.32,17.66Z",
    transform: "translate(-3 3.644)",
    fill: "#777"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAgregadores);
export default __webpack_public_path__ + "static/media/icon-agregadores.bf6439e8c698de35b8615603c72b6037.svg";
export { ForwardRef as ReactComponent };